import { Divider } from "antd";

const ShowFooterContentForSelect = ({ title, onClick }) => {
    return (
        <>
            <Divider style={{ margin: 0 }} />
            <div
                className="d-flex gap-1 align-items-center flex-row p-2 cursor-pointer"
                onClick={onClick}
                data-cy="add-user-footer-btn"
            >
                <div className="hs-color-violet hs-fw-500">+</div>
                <div className="hs-color-violet hs-fw-500">{title}</div>
            </div>
        </>
    );
};

export default ShowFooterContentForSelect;
